<template>
  <!-- 添加编辑 分词管理 -->
  <el-form
    ref="ruleFormRef"
    v-loading="loading"
    :model="ruleForm"
    :rules="rules"
    label-width="110px"
    class="demo-ruleForm"
    size="large"
    status-icon
  >
    <el-form-item label="分词名称" prop="words">
      <el-input
        class="middle_input"
        clearable
        v-model="ruleForm.words"
        placeholder="请填写分词名称"
      />
    </el-form-item>
    <el-form-item label="替代词名称" prop="replaceWords">
      <el-input
        class="middle_input"
        clearable
        v-model="ruleForm.replaceWords"
        placeholder="请填写替代词名称"
      />
    </el-form-item>
    <el-form-item label="排序值" prop="orderIndex">
      <el-tooltip
        class="item"
        effect="dark"
        content="排序值只能输入数字(整数),且排序值不能重复"
        placement="top"
      >
        <el-input
          class="middle_input"
          v-model.number="ruleForm.orderIndex"
          type="number"
          placeholder="请填写排序值"
          @mousewheel.prevent
          @keyup="prevent($event)"
        />
      </el-tooltip>
    </el-form-item>
    <el-form-item label="PC端网址" prop="pcUrl">
      <el-input
        class="big_input"
        clearable
        v-model="ruleForm.pcUrl"
        placeholder="请填写PC端网址"
      />
    </el-form-item>
    <el-form-item label="移动端网址" prop="mobileUrl">
      <el-input
        class="big_input"
        clearable
        v-model="ruleForm.mobileUrl"
        placeholder="请填写移动端网址"
      />
    </el-form-item>
  </el-form>
  <div slot="footer" class="from_btn">
    <el-button @click="resetForm" size="large">取消</el-button>
    <el-button type="primary" v-if="!submitDisabled" size="large" @click="submitForm(ruleFormRef)"
      :disabled = "submitDisabled">提交保存</el-button
    >
    <el-button type="primary" size="large" loading v-else>提交中</el-button>
  </div>
</template>

<script>
import { add, update } from "network/participleManagement.js";
import {
  toRefs,
  reactive,
  ref,
  unref,
  onMounted,
  toRaw,
  computed,
  watch,
} from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { isHttp } from "common/utils";
export default {
  name: "AddEditParticiple",
  components: {},
  emits: {
    "close-dialog": null,
    "update-list": null,
  },
  props: {
    editObj: Object,
    isEdit: Boolean,
  },
  setup(props, { emit }) {
    const ruleFormRef = ref();
    const data = reactive({
      loading: false,
      ruleForm: {
        words: "",
        replaceWords: "",
        pcUrl: "",
        mobileUrl: "",
        orderIndex: null,
      },
      rules: {
        words: [{ required: true, message: "请填写分词名称" }],
        replaceWords: [
          {
            required: true,
            message: "请填写替代词名称",
          },
        ],
        pcUrl: [
          {
            required: true,
            message: "请填写PC端网址",
          },
          {
            validator: (rule, value, callback) => {
              if (value && !isHttp(value)) {
                callback(new Error("PC端网址必须使用http或https开头"));
              } else {
                callback();
              }
            },
          },
        ],
        mobileUrl: [
          {
            required: true,
            message: "请填写移动端网址",
          },
          {
            validator: (rule, value, callback) => {
              if (value && !isHttp(value)) {
                callback(new Error("移动端网址必须使用http或https开头"));
              } else {
                callback();
              }
            },
          },
        ],
        orderIndex: [
          {
            required: true,
            message: "请填写排序值",
          },
          {
            validator: (rule, value, callback) => {
              if (value == 0) {
                callback(new Error("排序值必须大于0"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      submitDisabled:false,
    });

    onMounted(() => {});
    //编辑-获取详情
    if (props.isEdit && props.editObj) {
      data.ruleForm = JSON.parse(JSON.stringify(props.editObj));
    }

    // 提交
    const submitForm = async () => {
      const form = unref(ruleFormRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          return false;
        } else {
          data.submitDisabled = true;
          updataAdd().then(() => {
            data.submitDisabled = false;
          });
        }
      } catch (error) {
        ElMessage.error("有必填内容未填写！");
        console.log(error);
      }
    };
    async function updataAdd() {
      data.loading = true;
      let result = '';
      if (props.isEdit) {
        data.ruleForm.id = props.editObj.id;
        result = await update(data.ruleForm);
      } else {
        result = await add(data.ruleForm);
      }
      if (result && result.code == 1) {
        data.loading = false;
        ElMessageBox.alert(result.message, props.isEdit ? "编辑" : "添加", {
          confirmButtonText: "确定",
              });
        emit("close-dialog");
        emit("update-list");
      } else {
        data.loading = false;
        ElMessageBox.alert(result.message, props.isEdit ? "编辑" : "添加", {
          confirmButtonText: "确定",
                });
      }
    }
    // 取消操作  关闭弹窗
    const resetForm = () => {
      emit("close-dialog");
      ruleFormRef.value.resetFields();
    };
    //禁止输入小数以及负数
    const prevent = (e) => {
      var keynum = window.event ? e.keyCode : e.which; //获取键盘码
      if (keynum == 189 || keynum == 190 || keynum == 109 || keynum == 110) {
        ElMessage.warning("禁止输入小数以及负数");
        e.target.value = "";
      }
    };
    return {
      ...toRefs(data),
      ruleFormRef,
      submitForm,
      resetForm,
      prevent,
    };
  },
};
</script>
<style scoped>
:deep(.el-input__inner) {
  outline: none;
  line-height: 1px;
}

.demo-ruleForm {
  width: 100%;
  height: 350px;
}

>>> .el-form-item--large .el-form-item__content {
  line-height: 20px !important;
}
</style>

